var map = {
	"./1.png": 451,
	"./1_1.jpg": 279,
	"./1_2.jpg": 880,
	"./2.png": 160,
	"./2_1.jpg": 252,
	"./2_2.jpg": 699,
	"./3.png": 409,
	"./3_1.jpg": 601,
	"./3_2.jpg": 830,
	"./4.png": 14,
	"./4_1.jpg": 230,
	"./4_2.jpg": 809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;